<template>
  <div>
    <div
      class="body-1-bold inline-block"
      :class="{
        'text-static-default-hi-disabled': isOutOfStock,
      }"
    >
      <template v-if="isCartLocked || !link">
        {{ title }}
      </template>

      <RevLink
        v-else
        class="inline-block"
        :class="{
          '!text-static-default-hi-disabled': isOutOfStock,
        }"
        target="_blank"
        :to="link"
        :underlined="false"
      >
        {{ title }}
      </RevLink>
    </div>

    <ul class="my-4 flex flex-wrap gap-4">
      <li v-for="tag in tags" :key="tag" class="max-h-[20px]">
        <RevTag
          :class="{
            'text-static-default-hi-disabled': isOutOfStock,
          }"
          :label="tag"
          variant="secondary"
          variation="outline"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue'

import type { LinkInternal } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { RevTag } from '@ds/components/Tag'

import translations from './Description.translations'

const props = defineProps<{
  title: string
  link?: string | null | LinkInternal
  gradeId: number
  gradeName: string | null
  categoryId: number
  hasNewBattery: boolean
  isOutOfStock: boolean
}>()

const isCartLocked = inject('isCartLocked', false)

const i18n = useI18n()

const tags = computed(() => {
  const items = []

  items.push(props.gradeName)

  if (props.hasNewBattery) {
    items.push(i18n(translations.battery_new))
  }

  return items.filter(Boolean) as Array<string>
})
</script>
